import { render, staticRenderFns } from "./PayProcessListNew.vue?vue&type=template&id=6718dd7a"
import script from "./PayProcessListNew.vue?vue&type=script&lang=js"
export * from "./PayProcessListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports